import { useLayoutEffect, useState, useCallback } from "react";
import { stringify } from "qs";
import { history, goTo, getParams } from "../utils/history";

export const useLocation = () => {
  const [params, setParams] = useState(getParams());

  const go = useCallback(
    (p) => {
      const pa = {};
      const e = { ...params, ...p };

      for (var k in e) {
        if (!e[k]) continue;
        pa[k] = e[k];
      }

      goTo(stringify(pa));
    },
    [params]
  );

  useLayoutEffect(() => {
    const unlisten = history.listen((location, action) => {
      // debugger;
      setParams(getParams());
    });
    return unlisten;
  }, []);

  return { params, go };
};
